import mark from "../assets/vsescan-mark.svg";

export default function BrandMark({ className = "h-7 w-7" }) {
  return <img src={mark} alt="" aria-hidden="true" draggable={false} className={className} />;
}
